import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type { SvgIconComponent } from "@mui/icons-material";

export interface IntegrationMeta {
  identifier: string;
  name: string;
  description: MessageDescriptor;
  /** MUI icon component, or null for image-based icons (e.g. Google Sheets) */
  Icon: SvgIconComponent | null;
  /** Path to image asset, used when Icon is null */
  iconSrc?: string;
  /** Whether this integration supports "Sync now" */
  syncable: boolean;
}

export const INTEGRATIONS: IntegrationMeta[] = [
  {
    identifier: "business_central",
    name: "Microsoft Business Central",
    description: msg({
      context: "Integration description for Microsoft Business Central",
      message:
        "ERP and accounting - customers, vendors, invoices, orders, and finance data",
    }),
    Icon: null,
    iconSrc: new URL(
      "../../assets/microsoft-business-central-icon.svg",
      import.meta.url,
    ).href,
    syncable: true,
  },
  {
    identifier: "economic",
    name: "e-conomic",
    description: msg({
      context: "Integration description for e-conomic",
      message:
        "Accounting — customers, invoices, accounts, financial reporting",
    }),
    Icon: null,
    iconSrc: new URL("../../assets/economic-icon.jpg", import.meta.url).href,
    syncable: true,
  },
  {
    identifier: "intempus",
    name: "Intempus",
    description: msg({
      context: "Integration description for Intempus",
      message: "Time registration — work hours, absence, overtime, expenses",
    }),
    Icon: null,
    iconSrc: new URL("../../assets/intempus-icon.png", import.meta.url).href,
    syncable: true,
  },
  {
    identifier: "fenerum",
    name: "Fenerum",
    description: msg({
      context: "Integration description for Fenerum",
      message:
        "Subscription management — customers, subscriptions, invoices, MRR",
    }),
    Icon: null,
    iconSrc: new URL("../../assets/fenerum-icon.png", import.meta.url).href,
    syncable: true,
  },
  {
    identifier: "google_sheets",
    name: "Google Sheets",
    description: msg({
      context: "Integration description for Google Sheets",
      message: "User-provided spreadsheets — query data from connected sheets",
    }),
    Icon: null,
    iconSrc: new URL("../../assets/google-sheets-icon.svg", import.meta.url)
      .href,
    syncable: false,
  },
  {
    identifier: "rackbeat",
    name: "Rackbeat",
    description: msg({
      context: "Integration description for Rackbeat",
      message:
        "Inventory management — items, stock levels, purchase orders, sales orders",
    }),
    Icon: null,
    iconSrc: new URL("../../assets/rackbeat-logo.png", import.meta.url).href,
    syncable: true,
  },
];

export const getIntegrationMeta = (
  identifier: string,
): IntegrationMeta | undefined =>
  INTEGRATIONS.find((i) => i.identifier === identifier);
